import { TornadoWorkerPool } from "./tornadoWorkerPool";

// The worker pools shared by every tornado chart on the page.

const createWorker = async () => {
  const { default: TornadoWorker } = await import("./tornadoWorker?worker");
  return new TornadoWorker();
};

const cores =
  typeof navigator !== "undefined" ? navigator.hardwareConcurrency || 4 : 4;
// Leave a core for the page and one for the chart worker.
const PREDICTION_WORKERS = Math.min(Math.max(cores - 2, 1), 8);

let predictionPool: TornadoWorkerPool | undefined;
let chartPool: TornadoWorkerPool | undefined;

export const getPredictionPool = () =>
  (predictionPool ??= new TornadoWorkerPool(PREDICTION_WORKERS, createWorker));

export const getChartPool = () =>
  (chartPool ??= new TornadoWorkerPool(1, createWorker));
